import React, { PropsWithChildren, memo } from 'react';
import { ReactNode } from 'react';
import { Modal as ResponsiveModal } from 'react-responsive-modal';
export interface ModalProps {
  id?: string;
  children: ReactNode;
  open: boolean;
  classNames?: string;
  onClose: () => void;
  showHeader?: boolean;
  showCloseButton?: boolean;
  modalClassNames?: any;
  closeIcon?: any;
  width?: string;
}

const Modal = (props: PropsWithChildren<ModalProps>) => {
  const {
    id,
    open,
    onClose,
    classNames,
    children,
    showCloseButton,
    modalClassNames,
    closeIcon = null,
    width,
  } = props;

  return (
    <ResponsiveModal
      modalId={id}
      data-testid={id}
      open={open}
      onClose={onClose}
      center
      showCloseIcon={showCloseButton ? showCloseButton : false}
      closeIcon={closeIcon}
      classNames={{
        modal:
          modalClassNames?.modal ??
          `!p-0 !m-0 !align-bottom md:!align-middle max-h-[90%] min-w-[350px] max-w-[100%] w-[100%] md:w-[auto] md:max-w-2xl rounded-t-cs md:rounded-cs ${width}`,
      }}
    >
      <main className={`font-primary ${classNames}`}>{children}</main>
    </ResponsiveModal>
  );
};

export default memo(Modal);
